import { Route, Switch } from 'react-router';
import cn from 'classnames';

import LINK from 'constants/link.const';
import { useTheme } from 'providers/Theme.provider';

import { CustomAuthLayout } from './components/CustomAuth/CustomAuthLayout';
import ManagerLayout from './components/Manager/ManagerLayout';
import OrderReceivedLayout from './components/OrderReceived/OrderReceived';

import 'styles/stocks/layout.scss';

export const StocksRoutes = () => {
  const { isDarkMode, isLightMode, isBrightMode } = useTheme();

  return (
    <div
      className={cn('page-content stocks', {
        'light-class': isLightMode,
        'dark-class': isDarkMode,
        'bright-class': isBrightMode,
      })}
    >
      <Switch>
        <Route exact path={LINK.stocksManager} component={ManagerLayout} />
        <Route exact path={LINK.stocksUsedSold} component={ManagerLayout} />
        <Route exact path={LINK.stocksHolding} component={ManagerLayout} />
        <Route exact path={LINK.stocksMovement} component={ManagerLayout} />

        <Route path="/salon/:id/stocks/customauth" component={CustomAuthLayout} />
        <Route path="/salon/:id/stocks/orderReceived" component={OrderReceivedLayout} />
      </Switch>
    </div>
  );
};
